import { sendAccreditation } from '@/http/accreditationApi'

export class AccreditationService {
  async applicationAccreditation(userId) {
    const { data } = await sendAccreditation(userId)
    return data.message
  }
}
